export default __webpack_public_path__ + "static/cmetric-cfbe17beea060093afa625baec5d1233.png";